import { useEffect, useState, useContext, useCallback } from "react";
import { queryIndexInfo, queryIndexConfig } from "../js/request";
import { Context } from "../js/constant";
import { isObjectEmpty } from "../js/util";
import { setPageConfigAction } from "../actions";

interface IIndexDataType {
  state: number;
}
interface IConfigDataType {
  address?: string;
  mobile?: string;
  rescueH5Address?: string;
  fileSwitch?: number;
}

const DEFAULT_STATE = { state: 0 };

export default function useQueryIndexDataHook() {
  const { dispatch } = useContext(Context);
  const [indexData, setIndexData] = useState<IIndexDataType>(DEFAULT_STATE);
  const [pageConfigData, setPageConfigData] = useState<IConfigDataType>({});

  const loadConfigData = useCallback(() => {
    if (!isObjectEmpty(pageConfigData)) return;
    queryIndexConfig().then((ret) => {
      setPageConfigData(ret);
      dispatch(setPageConfigAction(ret));
    });
  }, [dispatch, pageConfigData]);

  useEffect(() => {
    const loadIndexData = () => {
      queryIndexInfo().then((ret = { data: DEFAULT_STATE }) => {
        const { data } = ret;
        setIndexData(data);
      });
    };
    loadConfigData();
    loadIndexData();
  }, []);

  return {
    indexData,
    pageConfigData,
  };
}
